export const keyPress = (targetKeys, isMenuActive, cb, ...args) => {

    let isMenuActiveClosure = isMenuActive;

    function menuState(menuState) {

        isMenuActiveClosure = menuState;

    }

    function downHandler({ key }) {

        const isKeyPressedTracked = targetKeys.some((trackedKey) => {

            return trackedKey === key;

        });

        if (isMenuActiveClosure && isKeyPressedTracked) {

            cb.apply(null, args);

        }

    }

    return {
        menuState,
        downHandler,
    };

};
